import React, { forwardRef } from "react";
import { FaSearch } from "react-icons/fa";

const NavbarSearchPanel = forwardRef(function NavbarSearchPanel(
  { term, setTerm, onSubmit, brandBg },
  ref,
) {
  return (
    <div
      ref={ref}
      className="fixed right-2 top-[86px] z-50 sm:right-4 md:top-[106px]"
    >
      <form
        onSubmit={onSubmit}
        className="flex w-[92vw] items-center gap-3 rounded-3xl border border-white/10 bg-slate-950 p-3 text-white shadow-2xl shadow-black/30 sm:w-[480px]"
      >
        <FaSearch className="h-5 w-5 text-white/70" />

        <input
          autoFocus
          type="text"
          value={term}
          onChange={(event) => setTerm(event.target.value)}
          placeholder="Rechercher un service, une page…"
          className="min-h-11 flex-1 bg-transparent text-base font-bold outline-none placeholder:text-white/55"
        />

        <button
          type="submit"
          className="min-h-11 rounded-2xl px-5 text-sm font-bold text-white"
          style={brandBg}
        >
          OK
        </button>
      </form>
    </div>
  );
});

export default NavbarSearchPanel;